import {IMuWidget} from "./IMuWidget";
import {wrapElement} from "./Utils";

export class UrlInput extends IMuWidget {
	beforeIndex() {
		const wrapped = wrapElement(<HTMLElement>this.container, 'div');
		this.container = wrapped.wrapper;
		wrapped.original.removeAttribute('mu-widget');
		wrapped.original.setAttribute('mu-id', 'input');
		this.container.innerHTML += `<a mu-id="link" target="_blank">Otevrít odkaz</a>`;
	}
	updateLink() {
		this.ui.link.href = this.ui.input.value;
		this.muVisible(!!this.ui.input.value, 'link');
	}
	afterIndex() {
		this.updateLink();
	}
	input_change() {
		this.updateLink();
	}
}